module.exports = __webpack_public_path__ + "img/plano-familiar.b519b4bc.jpeg";